import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useInvestorAuth } from '../context/InvestorAuthContext';

export default function InvestorPrivateRoute({ children }) {
  const { investor, investorLoading } = useInvestorAuth();
  const location = useLocation();
  if (investorLoading) return null;
  if (!investor) {
    return <Navigate to="/market/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
